<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="header" id="_idParaDest-2"><span class="Character-Style-1 CharOverride-8"><a id="_idTextAnchor001"></a>Islandport Press</span></p>
<p class="body-text ParaOverride-3"><span class="Character-Style-1 CharOverride-9">PO Box 10</span></p>
<p class="body-text ParaOverride-3"><span class="Character-Style-1 CharOverride-9">Yarmouth, Maine 04096 </span></p>
<p class="body-text ParaOverride-3"><span class="Character-Style-1 CharOverride-9">www.islandportpress.com </span></p>
<p class="body-text ParaOverride-3"><span class="Character-Style-1 CharOverride-9">info@islandportpress.com</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-10">Copyright © Islandport Press 2019</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-10">All rights reserved.</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-10">First Islandport Printing, 2019</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-10">eISBN: 978-1-944762-87-2</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-10">Library of Congress Card Number: 2019931597</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-10">Printed in USA.</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-10">Dean L. Lunt, Publisher</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-10">Book design, Teresa Lagrange</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-10">“Christmas in a One-Room Schoolhouse,” © May B. Davidson, 2019</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-10">“An Island Celebration,” © Dean L. Lunt, 2019</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-10">“Christmas Eve at the Chinese Buffet,” © Maureen Walsh</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-10">“Snowflakes of Christmas,” © Tristan Noyes, 2019</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-10">“Unwrapping,” © Shawn Callahan, 2019</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-10">For all other permissions, please see bibliography.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer009">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame _idGenObjectStyleOverride-1" id="_idContainer007">
</div>
</div>
<p class="Normal ParaOverride-1"><span class="CharOverride-11">“What happens to me when I cross the Piscataqua and plunge rapidly into Maine…I cannot describe it. I do not ordinarily spy a partridge in a pear tree, or three French hens, but I do have the sensation of having received a gift from a true love.”</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-12">—E.B. White</span></p>
<div class="_idGenObjectLayout-1">
<div id="_idContainer008">
<img alt="" class="_idGenObjectAttribute-1" src="image/icons_for_book1.jpg"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// All_is_calm_interior_epub2.vue?31aae39d